import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootEl = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// We deliberately client-render with createRoot even when the page was
// pre-rendered, rather than hydrateRoot. The prerender (prerender.js) writes a
// Playwright DOM *snapshot*, not React's own SSR output, so React 19's strict
// hydration always rejected it (missing hydration boundary markers; lazy route
// chunks aren't loaded at first paint, so React wants a Suspense fallback where
// the snapshot has the resolved page) and threw the recoverable #418, then
// re-rendered client-side anyway. createRoot skips that doomed hydration pass:
// the prerendered HTML is still served (crawlers + fast first paint via the
// inlined critical CSS), and React renders over it cleanly with no error.
// A true no-flash fix would require real SSR (renderToString), not a snapshot.
ReactDOM.createRoot(rootEl).render(tree);
